import { GetProfileQuery, ResumeAssessmentsReadyEnum } from "@graphql/generated";
import { create } from "zustand";

interface IProfileStoreState {
  name?: string;
  firstName?: string;
  lastName?: string;
  avatar?: string;
  email?: string;
  city?: string;
  country?: string;
  region?: string;
  hasResume?: boolean;
  hasProfile?: boolean;
  userResumeFile?: string;
  cpjResumeFile?: string;
  referralCode?: string;
  credits: number;
  score: number;
  completionPercentage: number;
  workexperiences?: NonNullable<GetProfileQuery["me"]>["workexperiences"];
  acceptTermsAndConditions: boolean;
  isOnboardingCompleted: boolean;
  industry?: string;
  interestedJobs?: string[];
  countryId?: string;
  newJobSuggestionsCount: number;
  resumeAssessmentsReady?: ResumeAssessmentsReadyEnum | null;
}

interface IProfileStoreAction {
  setProfile: (profile: GetProfileQuery) => void;
}

type TProfileStore = IProfileStoreState & IProfileStoreAction;

const initialState: IProfileStoreState = {
  name: "",
  avatar: "",
  email: "",
  city: "",
  country: "",
  region: "",
  hasResume: true,
  hasProfile: false,
  userResumeFile: "",
  cpjResumeFile: "",
  referralCode: "",
  credits: 0,
  score: 0,
  completionPercentage: 0,
  acceptTermsAndConditions: true,
  isOnboardingCompleted: true,
  newJobSuggestionsCount: 0,
};

export const useProfileStore = create<TProfileStore>((set) => ({
  ...initialState,

  setProfile: (profile) => {
    set(() => ({
      credits: profile.me?.profile?.credits ?? 0,
      score: profile.me?.profile?.score ?? 0,
      referralCode: profile.me?.referral?.code,
      name: `${profile.me?.firstName ?? ""} ${profile.me?.lastName ?? ""}`.trim(),
      firstName: profile.me?.firstName ?? "",
      lastName: profile.me?.lastName ?? "",
      avatar: profile.me?.profile?.avatar?.file || "",
      email: profile.me?.email,
      city: profile.me?.profile?.city?.name,
      country: profile.me?.profile?.city?.country?.name,
      countryId: profile.me?.profile?.country?.id,
      region: profile.me?.profile?.city?.region?.name,
      hasResume: !!profile.me?.hasResume,
      hasProfile: profile.me?.profile !== null,
      userResumeFile: profile.me?.resume?.file.file,
      cpjResumeFile: profile.me?.cv?.file,
      completionPercentage: profile.me?.profile?.completionPercentage ?? 0,
      workexperiences: profile.me?.workexperiences,
      acceptTermsAndConditions: profile.me?.profile?.acceptTermsAndConditions ?? true,
      isOnboardingCompleted: profile.me?.profile?.isOnboardingCompleted ?? true,
      industry: profile.me?.profile?.industry?.id,
      newJobSuggestionsCount: profile.me?.jobPositionAssignments?.totalCount ?? 0,
      resumeAssessmentsReady: profile.me?.resumeAssessmentsReady,
      interestedJobs: profile.me?.profile?.interestedJobs?.edges
        .map((job) => job?.node?.id)
        .filter((id): id is string => !!id),
    }));
  },
}));
